import $ from 'jquery';

function calculateItemsPerRow($element) {
    const $parent = $element.parent();

    return Math.round($parent.innerWidth() / $element.outerWidth(true));
}

export function partnersList($element) {
    $element.on('click', (event) => {
        event.preventDefault();
        const $clickedElement = $(event.target);
        const $captionSibling = $clickedElement.next('.partners-list__description');
        if ($captionSibling.length > 0) {
            if ($clickedElement.hasClass('opened')) {
                $element.removeClass('opened');
                $captionSibling
                    .slideUp(300, () => {
                    });
            } else {
                const itemsPerRow = parseInt(calculateItemsPerRow($element), 10);
                const clickedItemOrder = parseInt($clickedElement.css('order'), 10);

                const newOrder
                    = clickedItemOrder
                    + (itemsPerRow * Math.ceil(clickedItemOrder / itemsPerRow))
                    - (clickedItemOrder - 1);

                $('.partners-list__description')
                    .not($captionSibling)
                    .slideUp(300, () => {
                        $captionSibling
                            .css('order', newOrder)
                            .hide()
                            .slideDown(300, () => {
                            });
                    });

                $element.removeClass('opened');
                $clickedElement.addClass('opened');
            }
        }

        $(window)
            .resize(() => {
                $element.removeClass('opened');
                $('.partners-list__description').slideUp(300, () => {});
            });
    });
}
